import {useState, useCallback} from 'react'

type Status = 'idle' | 'loading' | 'success' | 'error'

export function useAsync<ReturnValue, T>(
  asyncFunction: (params: T) => Promise<ReturnValue>
) {
  const [status, setStatus] = useState<Status>('idle')
  const [data, setData] = useState<ReturnValue | null>(null)
  const [error, setError] = useState<unknown | null>(null)

  const isLoading = status === 'loading'
  const isSuccess = status === 'success'

  const run = useCallback(
    async (params: T) => {
      setStatus('loading')

      setData(null)
      setError(null)

      try {
        const res = await asyncFunction(params)
        setData(res)
        setStatus('success')
        return res
      } catch (err) {
        setError(err)
        setStatus('error')
      }
    },
    [asyncFunction]
  )

  const reset = useCallback(() => {
    setStatus('idle')
    setData(null)
    setError(null)
  }, [])

  return {run, status, isLoading, isSuccess, data, error, reset}
}
